import React, { useState } from 'react';

import { SurveyViewMode } from './types';
import SurveyList from '../../presentation/features/survey_red_cert/SurveyList/SurveyList';
import SurveyForm from '../../presentation/features/survey_red_cert/SurveyForm/SurveyForm';
import { BackButtonContainer } from '../../presentation/features/news/NewsPreview/styles';
import ActionButton from '../../presentation/components/ActionButton/ActionButton';
import { ContentWrapper, RedCertSection, SectionTitle } from './styles';
import { useI18n } from '../../hooks/useI18n';
import { TranslationKeys } from '../../i18n/locales/defaultResources';

const Survey = () => {
  const [viewMode, setViewMode] = useState<SurveyViewMode>('list');
  const [editingSurveyId, setEditingSurveyId] = useState<string | null>(null);
  const { t } = useI18n();

  const handleCreateNew = () => {
    setViewMode('create');
    setEditingSurveyId(null);
  };

  const handleEdit = (surveyId: string) => {
    setEditingSurveyId(surveyId);
    setViewMode('edit');
  };

  const handleCancel = () => {
    setViewMode('list');
    setEditingSurveyId(null);
  };

  const handleSurveyCreated = () => {
    setViewMode('list');
    setEditingSurveyId(null);
  };

  return (
    <RedCertSection>
      <SectionTitle>
        {t(TranslationKeys.survey_redcert_section_title)}
      </SectionTitle>
      <ContentWrapper>
        {viewMode === 'list' ? (
          <SurveyList onCreateNew={handleCreateNew} onEdit={handleEdit} />
        ) : (
          <>
            <BackButtonContainer>
              <ActionButton
                variant="link-button"
                buttonText={t(TranslationKeys.common_back_to_overview)}
                onClickAction={handleCancel}
                back={true}
              />
            </BackButtonContainer>
            <SurveyForm
              mode={viewMode}
              surveyId={editingSurveyId}
              onCancel={handleCancel}
              onSurveyCreated={handleSurveyCreated}
            />
          </>
        )}
      </ContentWrapper>
    </RedCertSection>
  );
};

export default Survey;
